<span class="d-inline-block text-logo-blue cursor-pointer text-underline lH-12" *ngIf="isMultipleCard">{{text}}</span>
<span *ngIf="!isMultipleCard">{{text}}</span>

